/**
 * Wait until timeout expires.
 */
export async function sleep(timeout: number) {
    return new Promise<void>(resolve => {
        setTimeout(resolve, timeout);
    });
}
